import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { colors } from '../../../../../../colorVars';
import { HoverBox } from './hoverBox/HoverBox';
import ApplyRounding from '../../../../../../utils/math/ApplyRounding';
import { useMouseCoordinates } from './MouseCoordinatesWrapper';
import { timeStampTo24HourEST } from '../../../../../../stores/websocketStore/utils/mungingUtils/timeFormatting/timeStampTo24HourEST';
import { timeStampToDate } from '../../../../../../stores/websocketStore/utils/mungingUtils/timeFormatting/timeStampToDate';

function Candle({ candle, portalRef, size, showCandleNumbers, timeUnit }) {
  const {
    rectWidth,
    rectHeight,
    rectYPos,
    rectXPos,
    fill,
    lineHeight,
    lineYPos,
    lineXPos,
    id,
    timeStamp,
    candleNumber,
    candleOpen,
    candleClose,
    candleHigh,
    candleLow,
  } = candle;
  const svgRef = useRef();
  const lineY1 = lineYPos;
  const lineY2 = lineYPos + lineHeight;
  const date =
    timeUnit === 'MINUTES'
      ? timeStampTo24HourEST(timeStamp)
      : timeStampToDate(timeStamp);
  const dateLabel = timeUnit === 'MINUTES' ? 'Time' : 'Date';
  const json = {
    [dateLabel]: date,
    Open: ApplyRounding(candleOpen, 2),
    Close: ApplyRounding(candleClose, 2),
    High: ApplyRounding(candleHigh, 2),
    Low: ApplyRounding(candleLow, 2),
  };
  const leftBoundary = rectXPos;
  const rightBoundary = rectXPos + rectWidth;
  const topBoundary = lineYPos;
  const bottomBoundary = lineYPos + lineHeight;
  const { coordinates } = useMouseCoordinates();
  const [x, y] = coordinates;

  return (
    <g
      fill={fill}
      style={{
        opacity:
          x > leftBoundary &&
          x < rightBoundary &&
          y > topBoundary &&
          y < bottomBoundary
            ? 1
            : 0.85,
      }}
      stroke={fill}
      strokeWidth={
        x > leftBoundary &&
        x < rightBoundary &&
        y > topBoundary &&
        y < bottomBoundary
          ? 3
          : 1
      }
      id={id}
      ref={svgRef}
      pointerEvents="bounding-box"
    >
      <rect x={rectXPos} y={rectYPos} width={rectWidth} height={rectHeight} />
      <line x1={lineXPos} y1={lineY1} x2={lineXPos} y2={lineY2} />
      {candleNumber !== 0 && showCandleNumbers ? (
        <text
          style={{ fontSize: '10px', fontWeight: 700 }}
          stroke={colors.white}
          fill={colors.white}
          x={lineXPos}
          y={lineY2 + 10}
          textAnchor="middle"
          strokeWidth={0}
        >
          {candleNumber}
        </text>
      ) : null}
      <HoverBox
        json={json}
        topBoundary={topBoundary}
        bottomBoundary={bottomBoundary}
        leftBoundary={leftBoundary}
        rightBoundary={rightBoundary}
        portalRef={portalRef}
        size={size}
      />
    </g>
  );
}

Candle.propTypes = {
  candle: PropTypes.shape({
    candleClose: PropTypes.any,
    candleHigh: PropTypes.any,
    candleLow: PropTypes.any,
    candleNumber: PropTypes.number,
    candleOpen: PropTypes.any,
    fill: PropTypes.string,
    id: PropTypes.number,
    lineHeight: PropTypes.number,
    lineXPos: PropTypes.number,
    lineYPos: PropTypes.number,
    rectHeight: PropTypes.number,
    rectWidth: PropTypes.number,
    rectXPos: PropTypes.number,
    rectYPos: PropTypes.number,
    timeStamp: PropTypes.number,
  }),
  portalRef: PropTypes.object,
  size: PropTypes.number,
  showCandleNumbers: PropTypes.bool,
  timeUnit: PropTypes.string
};

export default Candle;
